// extracted by mini-css-extract-plugin
var _1 = "ra-card-horizontal";
var _2 = "ra-card-horizontal-content";
var _3 = "ra-card-horizontal-content-paragraph";
var _4 = "ra-card-horizontal-media";
var _5 = "ra-card-horizontal-reversed";
export { _1 as "cardHorizontalCls", _2 as "cardHorizontalContentCls", _3 as "cardHorizontalContentParagraphCls", _4 as "cardHorizontalMediaCls", _5 as "cardHorizontalReversedCls" }
